<template>
    <div class="process-status-container">
        <div class="status-state" v-if="processStatus.state">
            <strong>{{statusLabelInner}}</strong> {{this.stateName}}
        </div>
        <div v-if="processStatus.messages.length || processStatus.responsesRaw.length">
            <div v-if="processStatus.messages.length" class="messages">
                <ul>
                    <li v-for="(message, messageIdx) in processStatus.messages" v-bind:key="messageIdx">
                        <span v-if="message.type">
                            <span v-if="message.type == processStatus.MESSAGE_TYPE_ERROR" class="message-error">
                                Error:
                            </span>
                            {{message.message}}
                        </span>
                        <span v-else>
                            {{message}}
                        </span>
                    </li>
                </ul>
            </div>
            <div v-if="processStatus.responsesRaw.length" class="response-raw">
                <div v-if="!responsesRawIsVisible">[<a href @click.prevent="responsesRawIsVisible = true">View raw API responses</a>]</div>
                <div v-if="responsesRawIsVisible">
                    <div>[<a href @click.prevent="responsesRawIsVisible = false">Hide raw API responses</a>]</div>
                    <strong>Raw API Response(s):</strong>:
                    <pre v-for="(responseRaw, responseRawIdx) in processStatus.responsesRaw" v-bind:key="responseRawIdx">{{responseRaw}}</pre>
                    <div>[<a href @click.prevent="responsesRawIsVisible = false">Hide raw API responses</a>]</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export var ProcessStatus;

Vue.util.extend(
    (ProcessStatus = function(initialState) {
        this.initialState = initialState;
        this.state = initialState;
        this.messages = [];
        this.responsesRaw = [];
    }).prototype,
    {
        MESSAGE_TYPE_ERROR: "error",
        MESSAGE_TYPE_LOG: "log",
        reset: function(params) {
            params = params || "default";
            params = (params == "default") ? "messages|responsesRaw" : params;
            params = (params == "all") ? "messages|responsesRaw|state" : params;
            params.split(/\|/).forEach(param => {
                if (param == "messages") {
                    this.messages.splice(0, this.messages.length);
                }
                if (param == "responsesRaw") {
                    this.responsesRaw.splice(0, this.responsesRaw.length);
                }
                if (param == "state") {
                    this.state = this.initialState;
                }
            });
        },
        push: function(type, message, responseRaw) {
            if (message) {
                type = type || this.MESSAGE_TYPE_LOG;
                this.messages.push({
                    type: type,
                    message: message
                });
            }
            if (responseRaw) {
                this.responsesRaw.push(responseRaw);
            }
        },
        log: function(message, responseRaw) {
            return this.push(this.MESSAGE_TYPE_LOG, message, responseRaw);
        },
        error: function(message, responseRaw) {
            return this.push(this.MESSAGE_TYPE_ERROR, message, responseRaw);
        }
    }
);

export default {
    name: 'ProcessStatusView',
    props: [
        "processStatus",
        "statusLabel"
    ],
    data: function() {
        return {
            responsesRawIsVisible: false,
            statusLabelInner: this.statusLabel || "Status:"
        }
    },
    computed: {
        stateName: function() {
            if (this.processStatus.states) {
                return this.states[this.processStatus.state];
            } else {
                return this.processStatus.state;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
</style>
